import type { ReactNode, HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'admin' | 'customer';
  header?: ReactNode;
  title?: string;
  action?: ReactNode;
}

export function Card({ variant = 'admin', header, title, action, children, className = '', ...props }: CardProps) {
  const base = variant === 'customer' ? 'card-customer' : 'card';
  return (
    <div className={`${base} ${className}`} {...props}>
      {(header || title || action) && (
        <div className="card-header">
          {header ?? (title && <h3 className="card-title">{title}</h3>)}
          {action && <div className="flex items-center gap-2">{action}</div>}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
}
